
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256 11.769c-141.16 0-256 95.84-256 213.639 0 62.485 32.091 120.894 88.398 161.534v113.29l117.453-65.347A305.651 305.651 0 00256 439.047c141.16 0 256-95.838 256-213.639C512 107.61 397.16 11.769 256 11.769zm92.17 226.567h-78.83v78.921c0 7.308-5.938 13.244-13.336 13.244a13.293 13.293 0 01-13.336-13.335v-78.83h-78.829A13.294 13.294 0 01150.503 225a13.294 13.294 0 0113.336-13.336h78.829v-78.829c0-7.399 6.029-13.336 13.336-13.336 7.398 0 13.336 6.029 13.336 13.336v78.829h78.921c7.398 0 13.336 6.028 13.336 13.336 0 7.398-6.029 13.336-13.427 13.336z"}})])
          )
        }
      }
    